import { Component, OnInit, signal, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseModal } from 'shared/abstract/base-modal';
import { Tab } from 'shared/interfaces/tab.interface';
import { EventBusService } from 'shared/services/event-bus.service';
import { unsubscribeFromAll } from 'shared/util/unsubscribeFromAll';
import { ShijiUserEditBasicComponent } from '../shiji-user-edit-basic/shiji-user-edit-basic.component';
import { ShijiUserEditPermissionsComponent } from '../shiji-user-edit-permissions/shiji-user-edit-permissions.component';

@Component({
    selector: 'app-edit-shiji-user',
    templateUrl: './shiji-user-edit.component.html',
    styleUrls: ['./shiji-user-edit.component.scss'],
    standalone: false,
})
//TODO: extract general edit-component
export class ShijiUserEditComponent extends BaseModal implements OnInit, OnDestroy {
    public data!: any;
    private subscriptions: { [key: string]: Subscription | undefined } = {};
    public tabs!: Tab[];

    private _selectedTabIndex = 0;
    public mainButtonLabel = signal<string | undefined>(undefined);
    private tabRouteMapping = ['basic', 'permissions'];

    constructor(private eventBusService: EventBusService) {
        super();
    }

    ngOnInit(): void {
        this.tabs = [
            {
                label: 'users.shijiUsers.edit.basic.label',
                component: ShijiUserEditBasicComponent,
                data: this.data,
            },
            {
                label: 'users.shijiUsers.edit.permissions.label',
                component: ShijiUserEditPermissionsComponent,
                data: this.data,
            },
        ];

        this.subscriptions.closeModalEvent = this.eventBusService
            .getObservableForEventStream('closeUserModal')
            .subscribe((data) => this.closeModalInstance(data));
    }

    ngOnDestroy() {
        unsubscribeFromAll(this.subscriptions);
    }

    public modalMainButtonAction() {
        this.eventBusService.dispatch('modalMainButtonAction', this.tabRouteMapping[this._selectedTabIndex]);
    }

    public closeModal() {
        this.closeModalInstance(undefined);
    }

    selectTab(event: any) {
        this._selectedTabIndex = event;
        this.mainButtonLabel.set(`users.shijiUsers.edit.buttonLabel.${this.tabRouteMapping[this._selectedTabIndex]}`);
    }
}
